import React, { useState } from 'react';

import { Baseurl } from '../lib/url';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { getMyWalks } from '../lib/getWalks';
import makeStyles from '@mui/styles/makeStyles';
import openInNewTab from '../_utils/Utils';
import { setToken } from '../lib/authentication';

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 2,

    "& .MuiTextField-root": {
      margin: 15,
      width: "300px"
    },
    "& .MuiButtonBase-root": {
      margin: 2,
      justifyContent: "center"

    }
  }
}));
const LoginView = props => {
  const [email, setEmail] = useState('');
  const [passwd, setPasswd] = useState('');
  const { onClose, open } = props;
  const classes = useStyles();
  const { setViewLoginOpen } = props;
  const { setViewRegisterOpen } = props;
  const { myWalks, setMyWalks } = props;
  const handleSubmit = (e) => {

    e.preventDefault();

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, password: passwd })
    };
    fetch(`${Baseurl}/login`, requestOptions)
      .then(response => response.json())
      .then(data => { setToken(data) })
      .then(() => setViewLoginOpen(false)).then(getMyWalks().then((walks) => setMyWalks(walks)));

      


  };
  const handleInfoClose = (evt) => {

  }

  const handleRegister = (evt) => {
    setViewRegisterOpen(true)
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="settings-dialog-title"
      open={open}
    >
      <DialogTitle id="settings-dialog-title"  className="dialogTitle">Login
      <IconButton onClick={onClose}>
          <CloseIcon style={{ color: "#ff334b" }}/>
        </IconButton>
      </DialogTitle>
      <form className={classes.root} onSubmit={handleSubmit}>
      <Box
    
        >
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Email Address"
          type="email"
          fullWidth
          onChange={(e) => setEmail(e.target.value)}

        />
        <TextField
          margin="dense"
          id="password"
          label="Password"
          type="password"
          fullWidth
          onChange={(e) => setPasswd(e.target.value)}

        />
        <DialogActions>
          <Button onClick={handleSubmit} color="primary">
            Login
          </Button>
          <Button onClick={handleRegister} color="primary">
            Register
          </Button>
        </DialogActions>
</Box>
      </form>

    </Dialog>
  );
};

export default LoginView;
